export default __webpack_public_path__ + "static/media/img-lp-somsak.8e88f0b4.svg";